import React from 'react';
import { Heart, ArrowUp } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', href: 'home' },
    { label: 'About', href: 'about' },
    { label: 'Experience', href: 'experience' },
    { label: 'Skills', href: 'skills' },
    { label: 'Projects', href: 'projects' },
    { label: 'Contact', href: 'contact' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0b] border-t border-[#1f1f23] py-12 relative">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* About */}
            <div>
              <div className="text-2xl font-bold mb-4">
                <span className="text-[#10b981]">&lt;</span>
                <span className="text-white">AY</span>
                <span className="text-[#10b981]">/&gt;</span>
              </div>
              <p className="text-[#a3a3a3] text-sm mb-4">
                Full Stack Developer passionate about creating innovative digital solutions.
              </p>
              <div className="flex gap-2 text-[#a3a3a3] text-sm">
                <MapPin size={16} className="text-[#10b981] mt-0.5" />
                <span>{personalInfo.location}</span>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-white font-semibold mb-4">Quick Links</h3>
              <div className="grid grid-cols-2 gap-2">
                {quickLinks.map((link) => (
                  <button
                    key={link.href}
                    onClick={() => scrollToSection(link.href)}
                    className="text-[#a3a3a3] hover:text-[#10b981] transition-colors duration-300 text-left text-sm"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-white font-semibold mb-4">Get In Touch</h3>
              <div className="space-y-2">
                <a
                  href={`mailto:${personalInfo.email}`}
                  className="text-[#a3a3a3] hover:text-[#06b6d4] transition-colors duration-300 text-sm block"
                >
                  {personalInfo.email}
                </a>
                <a
                  href={`tel:${personalInfo.phone}`}
                  className="text-[#a3a3a3] hover:text-[#06b6d4] transition-colors duration-300 text-sm block"
                >
                  {personalInfo.phone}
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-[#1f1f23] flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#a3a3a3] text-sm flex items-center gap-2">
              © {currentYear} {personalInfo.name}. Made with
              <Heart size={14} className="text-[#f97316] fill-current" />
              using React
            </p>
            <p className="text-[#a3a3a3] text-sm">
              Designed & Developed by {personalInfo.name}
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="absolute bottom-8 right-8 w-12 h-12 rounded-full bg-[#10b981] text-white flex items-center justify-center hover:bg-[#059669] transition-all duration-300 hover:scale-110 shadow-lg"
        aria-label="Scroll to top"
      >
        <ArrowUp size={20} />
      </button>
    </footer>
  );
};

// Missing import
import { MapPin } from 'lucide-react';

export default Footer;
